import { Injectable } from '@angular/core';
import { Router, CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { BaseService } from '../services/base.service';
import { ConstantsService } from '../services/constants.service';

@Injectable()

export class AuthGuard implements CanActivate, CanActivateChild {
    public loggedInuserDetails: any;
    public currentStartingURL: string;
    constructor(private router: Router, private baseService: BaseService) {
        const currentPointingUrl = this.baseService.getItemFromSession(ConstantsService.CurrentUserURL);
        if (currentPointingUrl === null || currentPointingUrl === "") {
            this.currentStartingURL = "";
            this.baseService.setItemInSession(ConstantsService.CurrentUserURL, null);
        }
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentPointingUrl = this.baseService.getItemFromSession(ConstantsService.CurrentUserURL);
        const loggedInUser = this.baseService.getItemFromSession('loggedInUser');
        if (!loggedInUser && this.currentStartingURL === "" && currentPointingUrl !== ConstantsService.NavigationStatus) {
            this.currentStartingURL = state.url;
            this.baseService.setItemInSession(ConstantsService.CurrentUserURL, this.currentStartingURL);
        }

        const currentUrl = state.url;
        if (currentUrl === "/" || currentUrl === "" || currentUrl === '/contractorlogin') {
            if(loggedInUser){
                this.router.navigate(['home']);
                  return false;
              }
            return true;
        }
        else if (!loggedInUser) {
             if( state.url.indexOf('pob-add-members') >= 0){
                return true;
              }
            this.router.navigate(['']);
            return false;
        }


        if (loggedInUser && currentPointingUrl !== "/" && currentPointingUrl !== ConstantsService.NavigationStatus) {
            let navigatingURL = '';
            navigatingURL = ConstantsService.URL.APP.substr(0, ConstantsService.URL.APP.length - 1) + currentPointingUrl;
            this.baseService.navigateToCurrentURLRoute(navigatingURL);
            this.baseService.setItemInSession(ConstantsService.CurrentUserURL, ConstantsService.NavigationStatus);
            return true;
        }


        return true;
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(childRoute, state);
    }
}
